import React, { useMemo } from "react";
import { css, useTheme } from "@emotion/react";

import FooterMenuBox from "core/Components/Footer/FooterMenuBox";
import FooterVerticalMenuBox from "core/Components/Footer/vertical/FooterVerticalMenuBox";
import useBreakpoint from "core/hooks/useBreakpoint";

type Props = {
    footerMenu: [any] | undefined,
};

const FooterMainSection: React.FC<Props> = ({ footerMenu }) => {
    const theme = useTheme();
    const { minWidth } = useBreakpoint();

    const showHorizontalMenu = useMemo(() => {
        switch (true) {
            case minWidth >= theme.breakpoints.sizes["lg"]:
                return true;
            default:
                return false;
        }
    }, [minWidth, theme.breakpoints.sizes]);

    const style = css`
        display: flex;
        justify-content: space-between;
        width: 100%;
    `;

    return (
        <div css={style}>
            {showHorizontalMenu ? (
                <FooterMenuBox footerMenu={footerMenu} />
            ) : (
                <FooterVerticalMenuBox footerMenu={footerMenu} />
            )}
        </div>
    );
};

export default FooterMainSection;
